module.exports = __webpack_public_path__ + "img/373841a665775f8c9521d9d3ab0d7da6.png";